import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Text, IconTick, Box } from 'braid-design-system';
import { observer } from 'mobx-react';

import { TimeAgo } from '../../common';
import HotjarMask from '../../common/HotjarMask';
import SyncMessage from '../../common/SyncMessage';

import translations from './.vocab';
interface Props {
  user: string;
  date: string;
  isNew: boolean;
  onHide: () => void;
  locale: Locale;
}

const ItemMeta = ({ user, date, isNew, onHide, locale }: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Box display="flex">
      <Box flexGrow={1}>
        <Text size="xsmall" tone="secondary">
          <HotjarMask>{user}</HotjarMask>
        </Text>
      </Box>
      <Box flexGrow={0}>
        <SyncMessage
          message={
            <Text tone="positive" size="xsmall">
              <IconTick /> {t('Added')}
            </Text>
          }
          showMessage={isNew}
          onHide={onHide}
        >
          <Text tone="secondary" size="xsmall">
            <TimeAgo date={date} locale={locale} size="small" />
          </Text>
        </SyncMessage>
      </Box>
    </Box>
  );
};

export default observer(ItemMeta);
